import RouteError from '~/client/components/RouteError'
import Layout from './Layout'

export default function (){
  return <Layout><RouteError/></Layout>
}
